import { useEffect, useState } from "react";
const isSSR = typeof window === "undefined";
const usePrefersReducedMotion = () => {
  const [prefersReducedMotion, setPrefersReducedMotion] = useState(isSSR);
  useEffect(() => {
    if (!window.matchMedia) {
      setPrefersReducedMotion(false);
      return;
    }
    const mediaQuery = window.matchMedia("(prefers-reduced-motion: reduce)");
    setPrefersReducedMotion(mediaQuery.matches);
    function onChange(event) {
      setPrefersReducedMotion(event.matches);
    }
    mediaQuery.addEventListener("change", onChange);
    return () => {
      mediaQuery.removeEventListener("change", onChange);
    };
  }, []);
  return prefersReducedMotion;
};
export {
  usePrefersReducedMotion
};
//# sourceMappingURL=use-prefers-reduced-motion.js.map
